import * as redis from "redis";
import {TokenCache, TokenCacheInitOptions} from "./tokencache";
import {timestamp, TokenType} from "../base/options";


/*
* redis 缓存 初始化参数
* */
export interface RedisCacheInitOptions extends TokenCacheInitOptions {

  /**
   * Redis 的地址
   */
  redisHost: string;
  /**
   * Redis 的端口
   */
  redisPort: number;
  /**
   * Redis 的密码
   */
  redisPassword?: string;
  /*
  * Redis app的键值
  * */
  redisAppKeyName?: string;
  /*
  * Redis 通讯录的键值
  * */
  redisMailKeyName?: string;
  /*
  * Redis 打卡的键值
  * */
  redisCheckInKeyName?: string;
  /*
  * Redis 审批的键值
  * */
  redisApprovalKeyName?: string;
}

/**
 * Wrapper of RedisClient.
 */
export class RedisCache extends TokenCache {
  private redisHost: string;
  private redisPort: number;
  private redisPassword: string;
  private redisAppKeyName: string;
  private redisMailKeyName: string;
  private redisCheckInKeyName: string;
  private redisApprovalKeyName: string;

  constructor(options: RedisCacheInitOptions) {
    super(options);
    this.redisHost = options.redisHost;
    this.redisPort = options.redisPort;
    this.redisPassword = options.redisPassword || "";
    this.redisAppKeyName = options.redisAppKeyName || "wechat:qiye:app_access_token";
    this.redisMailKeyName = options.redisMailKeyName || "wechat:qiye:mail_access_token";
    this.redisCheckInKeyName = options.redisCheckInKeyName || "wechat:qiye:checkin_access_token";
    this.redisApprovalKeyName = options.redisApprovalKeyName || "wechat:qiye:approval_access_token";
  }

  /**
   * @override
   */
  async updateToken(type: TokenType, data: string): Promise<void> {
    let redisKey: string = this.getRedisKeyName_(type);
    this.set(redisKey, data);
  }

  /**
   * @override
   */
  async getToken(type: TokenType): Promise<string> {
    let redisKey: string = this.getRedisKeyName_(type);
    const result: string = await this.get(redisKey);
    return result || "";
  }

  /*
  * 获取保存token的key
  * */
  private getRedisKeyName_(type: TokenType): string {
    switch (type) {
      case 0:
        return this.redisAppKeyName;
      case 1:
        return this.redisMailKeyName;
      case 2:
        return this.redisCheckInKeyName;
      case 3:
        return this.redisApprovalKeyName;
    }
    return "";
  }

  /**
   * Get value by key
   */
  async get(key: string): Promise<string> {
    return new Promise<string>(((resolve: (value: string) => void, reject: (error?: any) => void) => {
      let client: redis.RedisClient = this.createClient_();
      client.get(key, (err: Error | void, reply: string) => {
        client.quit();

        if (err) {
          reject(err);
        }
        resolve(reply);
      });
    }));
  }

  /**
   * Set value with key
   */
  set(key: string, value: string, expiredAt?: timestamp): void {
    if (expiredAt) {
      let client: redis.RedisClient = this.createClient_();
      client.set(key, value, function (err: Error | void, reply: string) {
        if (err) {
          client.quit();
          throw err;
        } else {
          client.expireat(key, expiredAt);
          client.quit();
          return;
        }
      });
    } else {
      let client: redis.RedisClient = this.createClient_();
      client.set(key, value, function (err: Error | void, reply: string) {
        client.quit();

        if (err) {
          throw err;
        } else {
          return;
        }
      });
    }
  }

  /*
  * redis client
  * */
  private createClient_(): redis.RedisClient {
    return redis.createClient({
      host: this.redisHost,
      port: this.redisPort,
      password: this.redisPassword
    });
  }
}
